export default "__VITE_ASSET__4f96a7a8__"